import tutcode from "../images/POS.png";
import enjeck from "../images/Pwebsite.png";
import ll from "../images/libre-logos.svg";
import gfolio from "../images/gfolio.png";
import jpg2svg from "../images/jpg2svg.png";
import gg from "../images/geo-guess.png";
import blobby from "../images/blobby.png";
import cav from "../images/CryptographyVisualizer.png"
import li from "../images/linkedIn-icon.png";
import gh from "../images/github-icon.png";
import email from "../images/gmail-icon.png";
import placeholder from "../images/bg1.png";
export const ImagesContent = [

  {
    link: `${window.location.origin}`,
    img: gfolio,
    name: "portfolio (this website)",
  },
  {
    link: "https://darshan01.netlify.app",
    img: enjeck,
    name: "Personal Website",
  },
  {
    link: "https://i.ibb.co/GFbr1d9/POS.png",
    img: tutcode,
    name: "POS",
  },
  
  {
    link: "https://www.linkedin.com/in/Darshandeepsingh",
    img: li,
    name: "LinkedIn - Connect and share experiences"
  },
];
